import animate, {tzAnimeInit} from './src/animation.js';
import offcanvas, {searchsOffcanvas} from './src/offcanvas.js';
import imageParallax from "./src/ImageParallax.js";
import scroll from "./src/scroll.js";
import loader from "./src/loader.js";
import TextAnimations from "./src/TextAnimations.js";
import {forEach} from "lodash/collection.js";
import progressBar from "./src/progressBar.js";
import counter from "./src/counter.js";
import shareHook from "./src/share.js";
import shuffleGrid from "./src/shuffle.js";
import priceToggle from "./src/priceToggle.js";
import portfolioFull from "./src/portfolioFull.js";
import stickyHeader from "./src/stickyHeader.js";


(function($) {
    'use strict';
    window.trazan = {
        loader,
        TextAnimations,
        animate,
        scroll,
        imageParallax,
        offcanvas,
        progressBar,
        counter,
        searchsOffcanvas,
        shareHook,
        shuffleGrid,
        portfolioFull,
        priceToggle,
        stickyHeader,
        init: function () {
            this.loader();
            this.onLoad();
            this.offcanvas();
            this.searchsOffcanvas();
            this.progressBar();
            this.counter();
            this.shareHook();
            this.shuffleGrid();
            this.priceToggle();
            this.portfolioFull();
            this.stickyHeader();
        },

        initElements: function () {
            const elements = document.querySelectorAll(('.tz-animated-text'));
            forEach( elements, (element) => {
                new window.trazan.TextAnimations(element);
            } );
        },
        onLoad: function () {
            const that = this;
            document.addEventListener('trazan:siteLoaderDone', () => {
                that.animate();
                that.scroll();
                that.initElements();
                tzAnimeInit();
            });
        }
    };
    window.trazan.init();

})(jQuery);